import React from 'react';
import PropTypes from 'prop-types';
import LanguageToggle from '@/components/common/LeftNavBarTabs/LanguageToggle';

const labelForEnv = (env: Environments) => (
  (['development', 'dev'].includes(env) ? env.slice(0, 3) : env.slice(0, 4)).toUpperCase()
);

interface EnvironmentLabelProps {
  environment: Environments;
  locale: Locale;
  programId: number;
  userType: UserType;
}

const EnvironmentLabel = ({ environment, locale, programId, userType }: EnvironmentLabelProps) => {
  if (!['ContentManager', 'SupportManager', 'Sysadmin'].includes(userType)) return <></>;

  return (
    <div className={`environment-label ${environment}`}>
      {environment && labelForEnv(environment)}
      {programId && (
        <LanguageToggle
          collapsed
          isAdminEnvironment
          colorMode=""
          copyright=""
          locale={locale}
        />
      )}
    </div>
  );
};

EnvironmentLabel.propTypes = {
  environment: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  programId: PropTypes.number.isRequired,
  userType: PropTypes.string.isRequired,
};

export default EnvironmentLabel;
